import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FieldDefValidations } from '@src/suite/common/enums/enums';

import { GlobalTablesState } from './global-tables.models';

const selectGlobalTablesState = createFeatureSelector<GlobalTablesState>('globalTables');

export const selectFieldDefsDict = createSelector(selectGlobalTablesState, state => state?.FieldDefsDict || {});

export const selectGroupSort = createSelector(selectGlobalTablesState, state => state?.GroupSort || null);

export const selectGroupSortDefs = createSelector(selectGroupSort, state => state?.groupSortDefs || {});

export const selectSecurityPrivileges = createSelector(selectGlobalTablesState, state => state?.securityPrivileges || {});

export const selectPSTGroupId = createSelector(selectGlobalTablesState, state => state?.PSTGroupId || null);

export const selectPSTGroupPrivileges = createSelector(selectSecurityPrivileges, selectPSTGroupId, (securityPrivileges, PSTGroupId) => {
    return securityPrivileges[PSTGroupId];
});
export const selectDateTimeFields = createSelector(selectGlobalTablesState, state => state?.DateTimeFields || {});

export const selectCustomFilterDefs = createSelector(selectGlobalTablesState, state => state?.CustomFilterDef);

export const selectCustomFilterDefsDict = createSelector(selectGlobalTablesState, state => state?.CustomFilterDefsDict);

export const selectPersonalTimeZone = createSelector(selectGlobalTablesState, state => state?.PersonalTimeZone);

export const selectPersonalTimeZoneDisplay = createSelector(selectGlobalTablesState, state => state?.PersonalTimeZoneDisplay);

export const selectClientTimeZone = createSelector(selectGlobalTablesState, state => state?.ClientTimeZone);

export const selectDefaultTimeZone = createSelector(selectGlobalTablesState, state => state?.DefaultTimeZone);

export const selectMosDevices = createSelector(selectGlobalTablesState, state => state?.MOSDevices || []);

export const selectAutoCreateMosDevices = createSelector(selectMosDevices, devices => {
    return devices.filter(device => device.AutoCreate);
});

export const selectCostFields = createSelector(selectGlobalTablesState, state => {
    return Object.values(state?.FieldDefsDict).filter(val => (val.Validation.toUpperCase() as FieldDefValidations) === FieldDefValidations.COST);
});

export const selectTopicCostFields = createSelector(selectCostFields, fields => {
    return fields.filter(field => field.TopicProp);
});

export const selectHasTopicCostFields = createSelector(selectTopicCostFields, fields => {
    return fields.length > 0;
});

export const selectAssignmentCostFields = createSelector(selectCostFields, fields => {
    return fields.filter(field => field.AssignmentProp);
});

export const selectHasAssignmentCostFields = createSelector(selectAssignmentCostFields, fields => {
    return fields.length > 0;
});
